import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Order from '../views/Order.vue'
import Finance from '../views/Finance.vue'
import Appointment from '../views/Appointment.vue'
import MetalManage from '../views/MetalManage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  {
    path: '/home',
    component: Home,
    meta: { requiresAuth: true },
    children: [
      // ✅ 首页占个坑
      {
        path: 'index',
        component: {
          render(h) {
            return h('div', '欢迎使用废旧金属回收后台')
          }
        },
        meta: { title: '首页' }
      },
      {
        path: 'order',
        component: Order,
        meta: { title: '订单审核' }
      },
      {
        path: 'appointment',
        component: Appointment,
        meta: { title: '预约受理' }
      },
      {
        path: 'finance',
        component: Finance,
        meta: { title: '提现审核' }
      },
      {
        path: 'metalType',
        component: MetalManage,
        meta: { title: '金属类型' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history', // 先保持这样，线上要配好服务器 history
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.matched.some(r => r.meta.requiresAuth) && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
